import { render, staticRenderFns } from "./messagePush.vue?vue&type=template&id=2b49000c&scoped=true&"
import script from "./messagePush.vue?vue&type=script&lang=js&"
export * from "./messagePush.vue?vue&type=script&lang=js&"
import style0 from "./messagePush.vue?vue&type=style&index=0&id=2b49000c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b49000c",
  null
  
)

export default component.exports